import { Swiper } from 'swiper';
import elementExists from '../../utils/elementExists';

const ProductCalloutSwiper = () => {
    const productCalloutSwiper = document.querySelectorAll( '.product-callout-slider' );
    if ( Object.keys(productCalloutSwiper).length ) {
        // Related Recipes Section
        productCalloutSwiper.forEach( function( el ){
            const container = el;
            const swiperContainer = container.querySelector( '.swiper');
            if( elementExists( swiperContainer)){
                const swiper = new Swiper( swiperContainer , {
                    direction: 'horizontal',
                    slidesPerView: 'auto',
                    spaceBetween: 30,
                    breakpoints: {
                        992: {
                            slidesPerView: 3,
                            spaceBetween: 15
                        },
                        1192: {
                            slidesPerView: 3,
                            spaceBetween: 120
                        }
                    }
                })
            }
        });
    }
}

export default ProductCalloutSwiper;